import { CLEAR_SUGGESTED_GROUPS } from '../actions/groups'

const groups = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_SUGGESTED_GROUPS:
      state = {}
      break
  }
  return state
}

export default groups
